"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var client = null;

var gmaps = gmaps || {};

gmaps.Client = gmaps.Client || function () {
    return function () {
        var self = {};

        var autocomplete = new google.maps.places.AutocompleteService();
        var geocoder = new google.maps.Geocoder();

        function normalizeGeocodeResult(result) {
            var geometry = result.geometry;
            if (geometry) {
                var location = geometry.location;
                if (location) {
                    geometry.location = {
                        lat: location.lat(),
                        lng: location.lng()
                    };
                }
            }
        }

        function normalizeResults(results, type) {
            if (!results) {
                return;
            }

            if (type === "geocode") {
                for (var i = 0, l = results.length; i < l; ++i) {
                    normalizeGeocodeResult(results[i]);
                }
            }
        }

        function wrapCallback(callback, type) {
            return function (results, status) {
                if (status === google.maps.GeocoderStatus.OK || status === google.maps.GeocoderStatus.ZERO_RESULTS) {
                    normalizeResults(results, type);
                    callback({
                        value: results
                    });
                } else {
                    callback({
                        error: {
                            code: status,
                            message: status
                        }
                    });
                }
            };
        }

        function defer(f) {
            setTimeout(f, 0);
        }

        self.autocomplete = function (params) {
            params = params || {};
            var request = params.request || {};
            var callback = params.callback || function () {};

            if (typeof request.location !== "undefined") {
                request.location = new google.maps.LatLng(request.location.lat, request.location.lng);
            }

            try {
                autocomplete.getPlacePredictions(request, wrapCallback(callback, "autocomplete"));
            } catch (e) {
                defer(function () {
                    callback({
                        error: {
                            code: "internal",
                            message: e.message
                        }
                    });
                });
            }
        };

        self.geocode = function (params) {
            params = params || {};
            var request = params.request || {};
            var callback = params.callback || function () {};

            try {
                geocoder.geocode(request, wrapCallback(callback, "geocode"));
            } catch (e) {
                defer(function () {
                    callback({
                        error: {
                            code: "internal",
                            message: e.message
                        }
                    });
                });
            }
        };

        return self;
    }();
};

function initFirst() {
    if (client) return;
    client = new gmaps.Client();
}

exports.default = {

    autocomplete: function autocomplete(params) {
        initFirst();
        client.autocomplete(params);
    },

    geocode: function geocode(params) {
        initFirst();
        client.geocode(params);
    },

    init: function init(params) {
        params = params || {};
        client = params.client || null;
    }

};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/GmapsService.js
// module id = 409
// module chunks = 0